import { Card, CardTitle } from '@/components/ui/card';

/**
 * Neutral placeholder for routes that exist in the nav but are out of scope
 * for this login+dashboard deliverable (Operativa console, RMS, etc.).
 */
export function PlaceholderScreen({ title }: { title: string }) {
  return (
    <div className="min-h-full bg-s-bg p-[22px]">
      <Card className="grid min-h-[240px] place-items-center p-[16px]">
        <div className="text-center">
          <CardTitle className="mb-2">{title}</CardTitle>
          <p className="font-mono text-[10px] uppercase tracking-[.5px] text-s-dim">
            Pantalla no incluida en este alcance
          </p>
        </div>
      </Card>
    </div>
  );
}
